import React, { FC } from 'react';
import { Control } from 'react-hook-form';

import { ChevronDownIcon } from '../../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../../../components/combobox/index';
import { TerminationCauseTitle } from '../../../../../types/stakeholder.types';
import { getTranslation } from '../../../../../utils/get-translation.util';
import { FormSchema } from '../terminate-stakeholder-modal.validation';

type TerminationItemsListProps = {
  control: Control<FormSchema>;
  index: number;
};

const TerminationItemsList: FC<TerminationItemsListProps> = ({ control, index }) => {
  return (
    <>
      {Object.entries(TerminationCauseTitle).map(([key, value]) => (
        <FormComboboxOption
          className="w-full"
          control={control}
          key={key}
          name={`terminateForm.stakeholderItems.${index}.terminationCause`}
          value={key}
        >
          <span className="text-sm text-gray-700">{<AppFormattedMessage id={value} />}</span>
        </FormComboboxOption>
      ))}
    </>
  );
};

export type TerminationTypeComboboxProps = {
  control: Control<FormSchema>;
  handleTerminationTypeChange: () => void;
  index: number;
};

export const TerminationTypeCombobox: FC<TerminationTypeComboboxProps> = ({
  control,
  index,
  handleTerminationTypeChange,
}) => {
  return (
    <FormCombobox
      className="w-[152px]"
      control={control}
      name={`terminateForm.stakeholderItems.${index}.terminationCause`}
      onSelect={handleTerminationTypeChange}
    >
      <div className="relative">
        <FormComboboxInput
          control={control}
          customValue={(value) => value && getTranslation(TerminationCauseTitle[value])}
          icon={<ChevronDownIcon />}
          name={`terminateForm.stakeholderItems.${index}.terminationCause`}
          readOnly
          wrapperClassName="h-10"
        />
        <ComboboxButton className="absolute left-0 top-0 z-20 h-full w-full" />
      </div>
      <ComboboxOptions className="z-20 max-h-[96px] w-fit overflow-x-hidden">
        <TerminationItemsList control={control} index={index} />
      </ComboboxOptions>
    </FormCombobox>
  );
};
